import React, { useEffect } from 'react';
import '../../App.css';
import './MangaPage.css';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import MangaApiService from '../../services/MangaApiService';
import MangaAccessNotice from './MangaAccessNotice';
import { MANGA_INACTIVITY_DAYS } from './mangaStudioUtils';

const MangaRulesPage = () => {
    const isAllowed = MangaApiService.isAllowedDomain();

    useEffect(() => {
        document.title = 'animix - Правила публикации манги';
    }, []);

    if (!isAllowed) {
        return (
            <PageShell>
                <MangaAccessNotice />
            </PageShell>
        );
    }

    return (
        <PageShell className="manga-rules-page">
            <PageHeader
                title="Правила публикации манги"
                lead="Эти правила обязательны для всех тайтлов и команд. Нарушения приводят к отклонению на модерации."
            />

            <div className="manga-rules-layout">
                <aside className="manga-rules-nav">
                    <div className="manga-rules-nav-title">Навигация</div>
                    <a href="#rules-team">Оформление команды</a>
                    <a href="#rules-manga">Загрузка манги</a>
                    <a href="#rules-pages">Загрузка страниц</a>
                    <a href="#rules-quality">Метаданные и качество</a>
                    <a href="#rules-moderation">Модерация и переносы</a>
                    <a href="#rules-restrictions">Что запрещено</a>
                </aside>

                <div className="manga-rules-content">
                    <section id="rules-team" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Правила оформления команды</h2>
                            <p className="manga-help">
                                Страница команды — это визитка. Мы ожидаем честное и аккуратное оформление.
                            </p>
                            <ul className="manga-rules-list">
                                <li>Запрещены плагиат, копии чужих команд, названия‑клоны и ложное позиционирование.</li>
                                <li>Нельзя использовать «апы», накрутку, агрессивный спам или вводящие в заблуждение описания.</li>
                                <li>Логотип и описание должны быть цензурными и без запрещённого контента.</li>
                                <li>Донаты допускаются только через Boosty или Patreon, без редиректов.</li>
                                <li>Запрещены ссылки на пиратские площадки, магазины аккаунтов или биржи.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="rules-manga" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Правила загрузки манги</h2>
                            <p className="manga-help">
                                Вы несёте ответственность за права на публикацию и корректность данных.
                            </p>
                            <ul className="manga-rules-list">
                                <li>Публикуйте только тайтлы, на которые у вас есть все необходимые права.</li>
                                <li>Переводы и сканы должны иметь разрешение правообладателя или официальной лицензии.</li>
                                <li>Обложка и описание обязаны соответствовать содержанию тайтла.</li>
                                <li>NSFW-контент обязательно помечайте соответствующим флагом.</li>
                                <li>Администрация может запросить подтверждение прав при спорных ситуациях.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="rules-pages" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Правила загрузки страниц</h2>
                            <p className="manga-help">
                                Цель — чистые и читабельные страницы без визуального мусора.
                            </p>
                            <ul className="manga-rules-list">
                                <li>Запрещены водяные знаки, чужие логотипы и крупные подписи поверх страниц.</li>
                                <li>Допускается одна последняя страница с ненавязчивой саморекламой команды.</li>
                                <li>Не допускаются дубликаты страниц, перемешанный порядок или пропуски.</li>
                                <li>Страницы должны быть в хорошем качестве без сильной компрессии и артефактов.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="rules-quality" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Метаданные и качество оформления</h2>
                            <ul className="manga-rules-list">
                                <li>Название, жанры и описание должны совпадать с содержанием тайтла.</li>
                                <li>Названия и контент должны быть на русском языке.</li>
                                <li>Допустимые жанры (строго по списку): Авангард, Гурман, Дзёсей, Драма, Комедия, Музыка, Повседневность, Приключения, Романтика, Сверхъестественное, Сёдзё, Сёнен, Спорт, Сэйнэн, Тайна, Триллер, Ужасы, Фантастика, Фэнтези, Экшен, Эротика, Этти.</li>
                                <li>Любые другие жанры или варианты написания одного жанра будут отклонены.</li>
                                <li>Нумерация глав и томов должна быть последовательной; нулевая глава допустима для пролога или спецглавы, дробные номера (например, 10.5) — для экстра- и промежуточных глав. Избегайте фиктивных значений вроде 9999.</li>
                                <li>При обновлениях не удаляйте историю глав без причины — используйте исправления.</li>
                                <li>Изменения главы или команды отправляют запись на повторную модерацию. Правки уже опубликованного тайтла применяются сразу, но остаются в истории действий: при нарушениях модерация может отклонить тайтл.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="rules-moderation" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Модерация и переносы</h2>
                            <ul className="manga-rules-list">
                                <li>При отклонении всегда указывается причина — исправьте и отправьте снова.</li>
                                <li>Если в тайтле {MANGA_INACTIVITY_DAYS} дней не выходит новых глав, администрация может передать его другой команде. Планируете перерыв — заранее сообщите модерации, чтобы сохранить тайтл за собой.</li>
                                <li>Если перевод закончен и новых глав не будет, отметьте в студии «Перевод завершён» — такой тайтл не считается заброшенным. Отметка на недопереведённом тайтле приравнивается к заброшенности.</li>
                                <li>Администрация может передать владение командой другому активному участнику при длительной инактивации владельца.</li>
                                <li>В спорных случаях решение принимает модерация после проверки истории действий.</li>
                            </ul>
                        </div>
                    </section>

                    <section id="rules-restrictions" className="manga-section manga-rules-section">
                        <div className="manga-panel">
                            <h2>Что запрещено</h2>
                            <ul className="manga-rules-list">
                                <li>Пиратские ссылки, продажа доступов, реклама обходов и сторонние «серые» сервисы.</li>
                                <li>Контент, нарушающий закон, правила платформы или авторские права.</li>
                                <li>Нецензурные логотипы, шок‑контент, разжигание ненависти и травля.</li>
                                <li>Любые попытки обхода модерации или повторные нарушения после предупреждений.</li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        </PageShell>
    );
};

export default MangaRulesPage;
